import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
import './index.css';
import { Capacitor } from '@capacitor/core';

async function initNativeUi() {
  if (!Capacitor.isNativePlatform()) return;
  try {
    const { StatusBar, Style } = await import('@capacitor/status-bar');

    // לא לשים את ה-StatusBar מעל ה-WebView — יציב, בלי קפיצות של header
    await StatusBar.setOverlaysWebView({ overlay: true });

    // באנדרואיד אפשר לצבוע את אזור הסטטוס־בר בלבן
    if (Capacitor.getPlatform() === 'android') {
      await StatusBar.setBackgroundColor({ color: '#FFFFFF' });
    }

    await StatusBar.show();
    // טקסט כהה על רקע בהיר
    await StatusBar.setStyle({ style: Style.Dark });
  } catch (e) {

  }
}

/**
 * מחכה עד ש --safe-top ייתן ערך אמיתי (לא 0) ויציב פעמיים ברצף,
 * ואז נועל אותו ומפעיל מצב header fixed.
 * (כשoverlay=false זה כמעט לא נדרש, אבל לא מזיק להשאיר.)
 */
function armHeaderWhenSafeTopStable() {
  const root = document.documentElement;
  const vv = (window as any).visualViewport as VisualViewport | undefined;

  let last = -1;
  let stableCount = 0;
  const deadline = performance.now() + 1500; // נסה עד 1.5 שניות

  const readSafeTop = () => {
    const raw = getComputedStyle(root).getPropertyValue('--safe-top').trim();
    const n = parseFloat(raw || '0');
    return Number.isFinite(n) ? n : 0;
    };

  const tick = () => {
    // לא “נועלים” בזמן שמקלדת פתוחה
    const keyboardOpen = vv ? (window.innerHeight - vv.height) > 120 : false;
    if (keyboardOpen) {
      requestAnimationFrame(tick);
      return;
    }

    const cur = readSafeTop();
    if (cur > 0 && Math.abs(cur - last) < 0.5) {
      stableCount++;
    } else {
      stableCount = 0;
    }
    last = cur;

    if (stableCount >= 2) {
      if (!root.style.getPropertyValue('--safe-top-locked')) {
        root.style.setProperty('--safe-top-locked', `${cur}px`);
      }
      root.classList.add('header-fixed-enabled');
      return;
    }

    if (performance.now() < deadline) {
      requestAnimationFrame(tick);
    } else {
      if (!root.style.getPropertyValue('--safe-top-locked')) {
        root.style.setProperty('--safe-top-locked', `${Math.max(cur, 0)}px`);
      }
      root.classList.add('header-fixed-enabled');
    }
  };

  requestAnimationFrame(tick);
}

function mount() {
  const rootEl = document.getElementById('root');
  if (!rootEl) return;

  createRoot(rootEl).render(
    <StrictMode>
      <App />
    </StrictMode>
  );

  // אפשר להשאיר — לא מזיק גם כשoverlay=false
  armHeaderWhenSafeTopStable();

  initNativeUi();
}

mount();
